/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import SocialSelection from 'app/components/SocialModal/SocialSelection.jsx';
import TypeSelection from 'app/components/SocialModal/TypeSelection.jsx';
import MastodonHandle from 'app/components/SocialModal/MastodonHandle.jsx';
import BlueskyCreds from 'app/components/SocialModal/BlueskyCreds.jsx';
import Loading from 'app/components/common/Loading.jsx';
import * as _ from 'underscore';

class CreateFeedSocial extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			view: ''
		};

		this.switchView = this.switchView.bind(this);

	}

	switchView(nextView) {

		if (['providehandle', 'blueskycreds'].indexOf(nextView) === -1) {
			nextView = '';
		}

		this.setState({
			view: nextView
		});

	}


	render() {
		let content = null,
			displayHeader = true,
			onboarding = null,
			constants = this.props.app.config.constants,
			twitterInput = false,
			twitterOutputs = 0,
			isBatchRunning = false;

		if (Object.keys(this.props.socials.batchCreates).length) {
			isBatchRunning = true;
		}

		if (this.props.route !== undefined &&
			this.props.route.inputs !== undefined &&
			this.props.route.inputs.length !== undefined) {
			for (let i = 0; i < this.props.route.inputs.length; ++i) {
				if (this.props.route.inputs[i].type !== undefined && this.props.route.inputs[i].type == constants.INPUT_TYPE_TWITTER) {
					twitterInput = true;
				}
			}
		}

		if (this.props.route !== undefined &&
			this.props.route.socials !== undefined &&
			this.props.route.socials.length !== undefined) {
			for (let i = 0; i < this.props.route.socials.length; ++i) {
				let social = _.find(this.props.socials, function(social) {
					return social.id == this.props.route.socials[i];
				}.bind(this));
				if (social) {
					if (social.psID == constants.POST_SVC_TWITTER) {
						++twitterOutputs;
					}
				}
			}
		};


		if (typeof(Storage) !== undefined) {
			onboarding = JSON.parse(window.localStorage.getItem('onboarding'));
		}

		if (this.props.socials.list.length <= 10) {
			displayHeader = false;
		}

		if (this.props.creatingSocial || isBatchRunning) {
			let label = "Connecting your social";

			if (isBatchRunning) {
				label = "Connecting your socials";
			}

			content = (
				<Loading label="Connecting your social"/>
			);

		} else if (this.state.view !== '') {
			switch (this.state.view) {
				case 'blueskycreds':
					content = (
						<div>
							<BlueskyCreds
								{...this.props}
								switchView={this.switchView}
								successCallback={() => {
									this.setState({
										view: ''
									});
								}}/>
						</div>
					);
					break;

				case 'providehandle':
					content = (
						<div>
							<MastodonHandle
								{...this.props}
								switchView={this.switchView}/>
						</div>
					);

				default:
					break;
			}
		} else if (this.props.socials.list.length === 0 && onboarding !== null) {
			content = (
				<div>
					<h3 className="social-buttons-header">Connect a social media profile</h3>
					<TypeSelection
						{...this.props}
						types={this.props.socials.types}
						recordPath={this.props.recordPath}
						redirect={this.props.redirect}
						onboarding={this.props.onboarding}
						switchView={this.switchView}
						extraClasses='onboarding'
						context='onboarding'
						hideTypes={[constants.POST_SVC_FEED]}
						twitterInput={twitterInput}
						twitterOutputs={twitterOutputs}/>
				</div>
			);
		} else {
			content = (
				<div>
					<SocialSelection
						{...this.props}
						displayHeader={displayHeader}
						onboarding={this.props.onboarding}
						context="input"
						outputs={this.props.outputs}
						searchHandler={this.props.socialSearch}
						filterHandler={this.props.socialFilter}
						socialClickHandler={this.props.socialClickHandler}
						selectedSocials={this.props.selectedSocials}
						connectHandler={this.props.connectHandler}
						twitterInput={twitterInput}
						twitterCount={twitterOutputs}
						mainTweeter={this.props.mainTweeter}
						setMainTweeter={this.props.setMainTweeter}
						resetTwitters={this.props.resetTwitters}
						topButton={this.props.topButton} />
				</div>
			);
		}

		return content;
	}
};

CreateFeedSocial.displayName = "CreateFeedSocial";

CreateFeedSocial.propTypes = {
	displayHeader: PropTypes.bool,
	socials: PropTypes.object,
	outputs: PropTypes.array,
	searchHandler: PropTypes.func,
	filterHandler: PropTypes.func,
	socialClickHandler: PropTypes.func,
	selectedSocials: PropTypes.array,
	connectHandler: PropTypes.func,
	creatingSocial: PropTypes.bool,
};

CreateFeedSocial.defaultProps = {
	displayHeader: true,
	socials: {},
	outputs: [],
	searchHandler: () => {},
	filterHandler: () => {},
	socialClickHandler: () => {},
	selectedSocials: [],
	onboarding: false,
	creatingSocial: false
};

export default CreateFeedSocial;
